"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransformValidateModel = exports.TransformValidateDateTime = exports.IsLessThan = exports.IsGreaterThan = void 0;
require("reflect-metadata");
const validator = __importStar(require("class-validator"));
const transformer = __importStar(require("class-transformer"));
const luxon_1 = require("luxon");
const utils_1 = require("./utils");
//
// TODO: Finish implementing this
//
//export class DateTime extends LuxonDateTime {
//  static serverTimestamp(value: unknown) {
//    const datetime = this.utc();
//
//    Object.assign(datetime, {
//      serverTimestamp: value,
//    });
//
//    return datetime;
//  }
//}
/**
 *
 * Verifies that the decorated property is greater than the
 * supplied 'property'.
 *
 */
function IsGreaterThan(property, validationOptions) {
    return function (object, propertyName) {
        validator.registerDecorator({
            name: 'isGreaterThan',
            target: object.constructor,
            propertyName: propertyName,
            constraints: [property],
            validator: {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                validate: (value, args) => {
                    const [relatedPropertyName] = args.constraints;
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    const relatedValue = args.object[relatedPropertyName];
                    return (value > relatedValue ||
                        ((validationOptions === null || validationOptions === void 0 ? void 0 : validationOptions.allowEqual) ? value === relatedValue : false));
                },
            },
        });
    };
}
exports.IsGreaterThan = IsGreaterThan;
/**
 *
 * Verifies that the decorated property is less than the
 * supplied 'property'.
 *
 */
function IsLessThan(property, validationOptions) {
    return function (object, propertyName) {
        validator.registerDecorator({
            name: 'isGreaterThan',
            target: object.constructor,
            propertyName: propertyName,
            constraints: [property],
            validator: {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                validate: (value, args) => {
                    const [relatedPropertyName] = args.constraints;
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    const relatedValue = args.object[relatedPropertyName];
                    return (value < relatedValue ||
                        ((validationOptions === null || validationOptions === void 0 ? void 0 : validationOptions.allowEqual) ? value === relatedValue : false));
                },
            },
        });
    };
}
exports.IsLessThan = IsLessThan;
/**
 *
 * Transform and validate a Luxon DateTime object.  When coming from
 * a plain JS object, valid inputs are:
 *
 *    - ISO string
 *    - JS Date object
 *    - Luxon DateTime object
 *    - Firestore Timestamp object
 *
 * When converting back to a plain JS object, this will convert the
 * Luxon DateTime object to a JS Date object.
 *
 */
const TransformValidateDateTime = () => {
    return (target, propertyKey) => {
        // Hack: This looks really stange, so here's what's going on.
        // When the incoming value is a string, DateTime or Date object,
        // we return the `Date` constructor which results in the transformation
        // library doing the "right thing".  If the incoming object has a `toDate`
        // property, we assume it is a Firestore `Timestamp` object and wrap it
        // in a function that returns the `Timestamp` object.  This stops the
        // transformation library from choking on the value which we will then
        // process later in `Transform`.
        transformer.Type(args => {
            if ((args === null || args === void 0 ? void 0 : args.newObject.constructor) === Object) {
                // Going to a plain object we convert the date to a string
                return Date;
            }
            const value = args === null || args === void 0 ? void 0 : args.object[args.property];
            if (value &&
                (value.toDate || value._seconds || value.constructor === Object)) {
                return function () {
                    return value;
                };
            }
            return Date;
        })(target, propertyKey);
        transformer.Transform(({ value }) => utils_1.toDateTime(value), { toClassOnly: true })(target, propertyKey);
        transformer.Transform(({ value }) => value.toUTC().toJSDate(), {
            toPlainOnly: true,
        })(target, propertyKey);
        validator.IsInstance(luxon_1.DateTime, {
            message: 'Value is not a supported date format',
        })(target, propertyKey);
    };
};
exports.TransformValidateDateTime = TransformValidateDateTime;
/**
 *
 * Transform and validate property as an instance of a {@linkcode Model}.  If
 * the property is actually and array of Model instances, make sure to pass
 * `{each: true}` in the validation options.
 *
 */
const TransformValidateModel = (model, validationOptions) => {
    return (target, propertyKey) => {
        // Convert to the model type
        transformer.Type(() => model)(target, propertyKey);
        // Validate the model
        validator.ValidateNested(validationOptions)(target, propertyKey);
        // Finally make sure that the result is actually an instance of model
        validator.IsInstance(model, validationOptions)(target, propertyKey);
    };
};
exports.TransformValidateModel = TransformValidateModel;
//# sourceMappingURL=decorators.js.map